module.exports = __webpack_public_path__ + "static/media/esa.311c4672.jpg";